import { useState, useEffect } from 'react'

// Components
import { Button, IconCheck, IconPen } from '@tracklib/kit'
import { Input } from 'components/form/inputs'

// Utils
import styles from './labelartistname.css'

type LabelArtistNameProps = {
  onReview: boolean
  labelArtistName?: string
}

const validateName = (value: string) => {
  let error
  if (value.length < 2) {
    error = 'Are you sure? This name seems too short'
  }
  return error
}

const LabelArtistName = (props: LabelArtistNameProps): JSX.Element => {
  const { onReview, labelArtistName } = props
  const [isEditing, setIsEditing] = useState(true)

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.textData}>{labelArtistName}</div>
        {onReview && !isEditing && (
          <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
            <IconPen />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <Input
        className={styles.inputField}
        id="label_artist_name"
        name="label_artist_name"
        type="text"
        autoComplete="label-artist-name"
        validate={validateName}
      />
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default LabelArtistName
